import { useEffect, useState } from 'react'
import { api, session } from '../api.js'
import RuleBuilder from '../components/RuleBuilder.jsx'

export default function Demarches() {
  const [liste, setListe] = useState([])
  const [enLigne, setEnLigne] = useState({})
  const [ouverte, setOuverte] = useState(null)
  const [message, setMessage] = useState('')

  const charger = () => {
    api.forms().then(setListe)
    api.formsStatus().then(setEnLigne).catch(() => setEnLigne({}))
  }
  useEffect(() => { charger() }, [])   // eslint-disable-line

  if (ouverte) return <Editeur formKey={ouverte} onRetour={() => { setOuverte(null); charger() }} />

  async function suspendre(f) {
    await api.suspend(f.key)
    setMessage(`« ${f.title} » est retirée du portail. Les dossiers en cours continuent normalement.`)
    charger()
  }
  async function reprendre(f) {
    await api.resume(f.key)
    setMessage(`« ${f.title} » est de nouveau visible sur le portail.`)
    charger()
  }

  return (
    <>
      <h1>Mes démarches</h1>
      <p className="chapo">Ce que voient les habitants. Vous pouvez changer les questions, l'ordre
        et le circuit de traitement à tout moment.</p>
      {message && <p className="succes" role="status">{message}</p>}
      <div className="grille">
        {liste.map((f) => (
          <article className="fiche" key={f.key}>
            <p className="cat">{f.category}</p>
            <h3>{f.title}</h3>
            <p className="mono petit">{f.questions} questions · circuit {f.workflow_key}</p>
            <div className="ligne">
              {enLigne[f.key]
                ? (enLigne[f.key].published
                    ? <span className="ok">en ligne</span>
                    : <span className="suspendue">suspendue</span>)
                : <span className="tag">pas encore publiée</span>}
              {f.featured && <span className="tag">mise en avant</span>}
            </div>
            <div className="ligne">
              <button className="btn sm" onClick={() => setOuverte(f.key)}>Modifier</button>
              {enLigne[f.key] && (enLigne[f.key].published
                ? <button className="btn sm dgr" onClick={() => suspendre(f)}
                          title="Retire la démarche du portail tout de suite, sans publier vos autres travaux">
                    Suspendre
                  </button>
                : <button className="btn sm" onClick={() => reprendre(f)}>Remettre en ligne</button>)}
            </div>
          </article>
        ))}
      </div>
    </>
  )
}

function Editeur({ formKey, onRetour }) {
  const [form, setForm] = useState(null)
  const [choisi, setChoisi] = useState(null)
  const [vocabulaire, setVocabulaire] = useState([])
  const [message, setMessage] = useState('')

  useEffect(() => { api.form(formKey).then(setForm) }, [formKey])

  // Les règles ne portent que sur des questions déjà posées : on ne propose
  // jamais une question qui vient après.
  useEffect(() => {
    if (!form || !choisi) return setVocabulaire([])
    const index = form.fields.findIndex((f) => f.varname === choisi)
    setVocabulaire(form.fields.slice(0, index)
      .filter((f) => f.varname && !['page', 'title', 'comment'].includes(f.type))
      .map((f) => ({
        var: 'form_var_' + f.varname, label: f.label, type: f.type, options: f.options || [],
        operators: operateurs(f),
      })))
  }, [form, choisi])

  if (!form) return <p className="chargement">Chargement…</p>
  const champ = form.fields.find((f) => f.varname === choisi)

  async function enregistrer(fields) {
    setForm({ ...form, fields })
    await api.saveForm(formKey, { fields })
    setMessage('Enregistré. Pensez à mettre votre portail à jour.')
  }

  return (
    <>
      <button className="retour" onClick={onRetour}>← Mes démarches</button>
      <h1>{form.title}</h1>
      {message && <p className="succes" role="status">{message}</p>}

      <div className="deux">
        <section className="carte">
          <h2>Les questions</h2>
          <ol className="questions">
            {form.fields.map((f, i) => (
              <li key={i} className={choisi === f.varname ? 'on' : ''}>
                <button onClick={() => setChoisi(f.varname)}>
                  <span className="type">{f.type}</span>
                  <span className="lib">{f.label}</span>
                  {f.when && <span className="regle-resume">{f.when}</span>}
                </button>
              </li>
            ))}
          </ol>
        </section>

        <aside className="carte">
          {champ ? (
            <>
              <h2>{champ.label}</h2>
              <RuleBuilder
                vocabulaire={vocabulaire}
                valeur={champ.condition}
                onChange={(condition) => {
                  const fields = form.fields.map((f) =>
                    f.varname === choisi ? { ...f, condition } : f)
                  enregistrer(fields)
                }} />
            </>
          ) : <p className="aide">Choisissez une question à gauche pour décider quand elle apparaît.</p>}
        </aside>
      </div>
    </>
  )
}

function operateurs(f) {
  if (f.type === 'checkbox') return [{ op: 'oui', label: 'est cochée' }, { op: 'non', label: "n'est pas cochée" }]
  if (f.type === 'number') return [
    { op: '==', label: 'est' }, { op: '!=', label: "n'est pas" },
    { op: '>', label: 'est plus grand que' }, { op: '<', label: 'est plus petit que' },
    { op: 'not_empty', label: 'a été rempli' }, { op: 'is_empty', label: "n'a pas été rempli" }]
  if (f.options?.length) return [
    { op: '==', label: 'est' }, { op: '!=', label: "n'est pas" },
    { op: 'not_empty', label: 'a été rempli' }, { op: 'is_empty', label: "n'a pas été rempli" }]
  return [
    { op: 'not_empty', label: 'a été rempli' }, { op: 'is_empty', label: "n'a pas été rempli" },
    { op: '==', label: 'est' }, { op: 'contains', label: 'contient' }]
}
